import { registerSchema } from "@/features/auth/schemas/auth.schema";
import { z } from "zod";

export enum AuthState {
  IDLE = "idle",
  AUTHENTICATING = "authenticating",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
  LOGOUT = "logout",
}

export type RegisterInput = z.infer<typeof registerSchema>;

export interface LoginInput {
  email: string;
  password: string;
}

export interface AuthResponse {
  user: {
    id: string;
    email: string;
    name: string;
  };
  token: string;
  expiresAt: Date;
}

export interface SessionValidationResponse {
  user: {
    id: string;
    email: string;
    name: string;
  };
  expiresAt: Date;
}

export interface AuthErrorResponse {
  success: false;
  error: string;
}

export interface UpdatePasswordInput {
  id: string;
  currentPassword: string;
  newPassword: string;
}
